import { customEvent, generateLeadEvent, trackPageView } from '../modules/tracking/AnalyticsEvents';

async function initPage() {
    const contactUsFormValidator = new ContactFormValidator({
        target: '#contactForm',
        custom: {
            'own_vehicle': function (el) {
                const department = document.querySelector('#contactUs-type_of_enquiry');
                if (department.value == 3 || department.value == 4) {
                    return true;
                }

                if (el.value === '') {
                    return {
                        valid: false,
                        message: 'Please select an option'
                    }
                }

                return true;
            }
        }
    });

    const locationHandler = new CustomerLocationHandler();
    const locationData = await window.LocationDataLoader.get();
    const contactFormText = document.querySelector('.cms-contact-form__text');

    // detect if form is complaint form
    const complaintForm = contactFormText.dataset.isComplaintForm === 'true';

    if (complaintForm === true) {
        const department = document.querySelector('#contactUs-type_of_enquiry')
        const ownVehicle = document.querySelector('#contactUs-own_vehicle')
        department.addEventListener('change', function () {
            if (this.value == 3 || this.value == 4) {
                ownVehicle.style.display = 'none';
            } else {
                ownVehicle.style.display = 'block';
            }
        })
    }

    locationHandler.setLocationData(locationData);
    locationHandler.setup('contactForm');

    contactForm.addEventListener('submit', async function(e) {
        e.preventDefault();

        if (!await contactUsFormValidator.isValid()) {
            return false;
        }
        const formData = $(contactForm).serializeArray();
        contactUsFormValidator.preventInput();
        $.ajax({
            url: contactForm.getAttribute('action'),
            type: "POST",
            data: formData,
            cache: false,
            dataType: "json",
            success: function (response) {
                window.scrollTo({ top: $('#contactForm').offset().top - 200, behavior: 'smooth' });

                customEvent('Contact Us', 'Completed', 'Complete');
                trackPageView('/conversion/contact-us/complete', 'Contact Us Completed');
                generateLeadEvent('contact_us');
                generateLeadEvent('contact_us_combined');

                contactFormText.style.display = 'none';
                if (complaintForm === true) {
                    // get option text from selected value
                    // const dealer = response.dealer;
                    const referenceNumber = response.referenceNumber;
                    contactForm.innerHTML = `
                        <h3 class="cms-content-heading" style="font-size: 20px;font-weight: 700;margin: 0;">Thank you for getting in touch</h3>
                        <p>Reference Number: ${referenceNumber}</p>
                        <p>We have received your information and appreciate you taking the time to complete the form.</p>
                        <p>A member of the team will review the details you have supplied and create a case, sending you an email confirmation when this has been done.</p>
                        <p>Please note that we operate Monday to Friday 9am to 5pm.</p>
                        <p>Kind Regards, <br> Stellantis &You UK</p><br>
                    `;
                } else {
                    contactForm.innerHTML = `
                        <h3 class="cms-content-heading" style="font-size: 20px;font-weight: 700;margin: 0;">Thank you for your enquiry</h3>
                        <p>We have sent your details to our centralised team who will be in contact with you shortly to discuss your enquiry.</p>
                        <p>Kind Regards, <br> Stellantis &You UK</p>
                    `;
                }
                contactUsFormValidator.allowInput();
            },
            error: function (response) {
                contactUsFormValidator.errorResponse(response);
            }
        });
    });
}

initPage();



// WEBPACK FOOTER //
// ./resources/assets/js/contactUs/index.js